/* ==========================================================================
   Signal de defilement pour l'en-tete Yzavo.

   Pourquoi ce fichier existe. L'en-tete mobile doit avoir deux etats : blanc
   pleine largeur en haut de page, pilule arrondie detachee des le debut du
   defilement. Il fallait donc un marqueur en CSS disant « on a defile ».

   La classe shopify-section-header-sticky de Dawn ne convient pas : avec le
   reglage sticky_header_type = always, elle est posee des le chargement et
   n'est jamais retiree. Verifie sur la page rendue : identique a 0 px et a
   900 px de defilement. S'en servir aurait affiche la pilule en permanence,
   c'est-a-dire l'inverse de ce qui est demande.

   Pourquoi un IntersectionObserver plutot qu'un simple ecouteur de
   defilement. Une premiere version ne s'appuyait que sur l'evenement scroll
   de window. Verifie sur la page rendue : un evenement emis a la main
   declenchait bien la bascule, mais un defilement reel ne la declenchait pas.
   L'observateur, lui, ne depend pas de la facon dont la page defile : il
   signale simplement qu'un repere place tout en haut du document est sorti
   de l'ecran. L'ecouteur de defilement est conserve en second rideau, au cas
   ou l'observateur ne serait pas disponible.

   PIEGE A CONNAITRE, rencontre deux fois dans ce chantier. Dawn masque tout
   element vide par la regle div:empty { display: none; } de assets/base.css.
   Elle a d'abord rendu inutilisables les ancres de navigation, puis le repere
   de cet observateur. Tout element vide ajoute a ce theme, ancre ou repere,
   doit donc porter un display explicite, sans quoi il est masque et devient
   invisible aussi bien au defilement qu'a l'observateur.
   ========================================================================== */

(function () {
  'use strict';

  // Quelques pixels suffisent : le changement doit se declencher des que le
  // doigt commence a faire remonter la page, pas apres un long defilement.
  var SEUIL = 8;

  var dernierEtat = null;

  function basculer(defile) {
    // On n'ecrit dans le DOM que si l'etat change reellement, pour ne pas
    // declencher un recalcul de style inutile.
    if (defile === dernierEtat) return;
    dernierEtat = defile;
    document.body.classList.toggle('yzavo-defile', defile);
  }

  function demarrer() {
    // Repere invisible pose tout en haut du document. Tant qu'il est a
    // l'ecran, on est en haut de page ; des qu'il en sort, on a defile.
    var repere = document.createElement('div');
    repere.setAttribute('aria-hidden', 'true');
    // display:block est indispensable et non decoratif. Dawn masque tout
    // element vide par la regle div:empty { display: none; } de base.css.
    // Un repere masque n'est jamais considere comme visible par l'observateur :
    // isIntersecting resterait faux en permanence, la classe serait posee des
    // le haut de page, soit exactement l'inverse du comportement voulu.
    // Constate sur la page rendue avant correction : hauteur du repere a 0 px
    // et classe yzavo-defile presente a un defilement de 0.
    repere.style.cssText =
      'display:block;position:absolute;top:0;left:0;width:1px;height:' +
      SEUIL + 'px;pointer-events:none;visibility:hidden;';
    document.body.insertBefore(repere, document.body.firstChild);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        basculer(!entrees[0].isIntersecting);
      }, { threshold: 0 }).observe(repere);
    }

    // Second rideau : utile si l'observateur est indisponible, et sans effet
    // s'il fonctionne, puisque basculer() ignore un etat identique.
    window.addEventListener(
      'scroll',
      function () { basculer(window.scrollY > SEUIL); },
      { passive: true }
    );

    // Au chargement : une page rouverte peut etre restauree deja defilee.
    basculer(window.scrollY > SEUIL);
  }

  if (document.body) {
    demarrer();
  } else {
    document.addEventListener('DOMContentLoaded', demarrer);
  }
})();